import { defineMessages } from 'react-intl';

export default defineMessages({
  warrantyHeading: {
    id: 'ExtendWarrantyHeader.warrantyHeading',
    defaultMessage: '{product} Accident Protection',
  },
});
